const Content = ({ children }) => (
  <div id="mainContent" className="content p-0">
    {children}
  </div>
);

export default Content;
